import {connect} from 'react-redux'
import * as ordersActions from "../actions/ordersActions";
import OrderStatusScheduler
    from "../../Components/Orders/OrdersGrid/OrderStatus/OrderStatusScheduler/OrderStatusScheduler";

const mapStateToProps = () => {
    return {};
};

const mapDispatchToProps = {
    editOrder: ordersActions.editOrderAction
};

const OrderStatusSchedulerContainer = connect(mapStateToProps, mapDispatchToProps)(OrderStatusScheduler);

export default OrderStatusSchedulerContainer;